"use client";

import type { MacaronRenderContext, RecordAny } from "./types";

export function MacaronFullScreenModal({ config, ctx }: { config: RecordAny; ctx: MacaronRenderContext }) {
  const entryPointChild = typeof config.entryPointChild === "string" ? config.entryPointChild : "";
  return entryPointChild ? <>{ctx.renderChild(entryPointChild)}</> : null;
}
